import axios from 'axios'
import getHeaders from '../helpers/headers'
import config from '../../constants/endpoints.js'

const { inchat } = config.endpoints

/**
 *
 * @param {string} conversationId
 * @param {object} data
 * @returns {any}
 */
const updateConversation = (conversationId, data) => axios({
  method: 'PUT',
  url: inchat.conversation.replace(':conversationId', conversationId),
  data,
  headers: getHeaders(true)
})

/**
 *
 * @param {object} data
 * @param {'direct'|'group'} data.type
 * @param {number} data.limit
 * @param {number} data.page
 * @returns
 */
const getConversationList = (data) => axios({
  method: 'post',
  url: inchat.conversationList,
  data,
  headers: getHeaders(true)
})

const getMainMenuInchat = () => axios({
  method: 'get',
  url: inchat.mainMenu,
  headers: getHeaders(true)
})

/**
 *
 * @param {String} idGroup
 * @param {Object} params
 * @param {Number} params.page
 * @param {Number} params.limit
 * @returns
 */
const getSectionInfo = (idGroup, params) => axios({
  method: 'get',
  url: inchat.sections.replace(':groupId', idGroup),
  params: params,
  headers: getHeaders(true)
})

/**
 *
 * @param {String} idGroup
 * @param {Object} data
 * @param {String[]} [data.conversationId]
 * @param {String} [data.name]
 * @param {String[]} [data.conversationIds]
 * @param {'add'|'remove'} [data.actionConversation]
 * @param {'all'|'unread'} [data.showFilter]
 * @param {'asc'|'desc'|'recentActivity'} [data.orderFilter]
 * @returns
 */
const updateSectionInfo = (idGroup, data) =>  axios({
  method: 'put',
  url: inchat.sections.replace(':groupId', idGroup),
  data,
  headers: getHeaders(true)
})

const deleteSection = (idGroup) => axios({
  method: 'delete',
  url: inchat.sections.replace(':groupId', idGroup),
  headers: getHeaders(true)
})

/**
 *
 * @param {Object} data
 * @param {String[]} data.newConversationsOrder
 */
const orderSections = (data) => axios({
  method: 'post',
  url: inchat.sectionsOrder,
  data,
  headers: getHeaders(true)
})

const createConversation = (data) => axios({
  method: 'post',
  url: inchat.createConversation,
  data,
  headers: getHeaders(true)
})

const searchUsers = (data) => axios({
  method: 'post',
  url: inchat.searchUser,
  data,
  headers: getHeaders(true)
})

/**
 * 
 * @param {Object} data 
 * @param {string} data.conversationId
 * @returns 
 */
const getConversationInfo = (data) => axios({
  method: 'post',
  url: inchat.infoConversation,
  data,
  headers: getHeaders(true)
})

/**
 * 
 * @param {Object} data 
 * @param {Object} data.type
 * @param {string} data.conversationId
 * @param {Object} data.message
 * @param {Object} data.attachments
 * {
      "url": "string",
      "urlLong": "string",
      "mimeType": "string",
      "mimeSubtype": "string",
      "fileId": "string",
      "thumb": "string",
      "thumbId": "string",
      "extension": "string"
    }
 * @param {Object} data.parentId
 * @returns 
 */
const sendMessage = (data) => axios({
  method: 'post',
  url: inchat.sendMessage,
  data,
  headers: getHeaders(true)
})

const uploadFiles = (data) => axios({
  method: 'post',
  url: inchat.resource,
  data,
  headers: getHeaders(true)
})

const getConversationMessages = data => axios({
  method: 'post',
  url: inchat.conversationMessages,
  data,
  headers: getHeaders(true)
})

/**
 *
 * @param {Object} data
 * @param {'mute'|'unmute'|'kick'|'leave'|'invite'|'join'|'update'|'remove'} data.type
 * @param {'channel'|'direct'|'group'} data.conversationType
 * @param {String} data.conversationId
 * @param {String[]} [data.userIds]
 * @param {Boolean} [data.mute]
 * @param {Object} [data.data]
 * @param {String} [data.data.name]
 * @param {String} [data.data.description]
 * @param {Boolean} [data.data.private]
 * @returns
 */
const actionConversation = (data) => axios({
  method: 'post',
  url: inchat.actionConversation,
  data,
  headers: getHeaders(true),
})

/**
 *
 * @param {Object} data
 * @param {String} [data.name]
 * @param {Number} [data.page]
 * @param {Number} [data.limit]
 * @returns
 */
const getAllChannels = (data) => axios({
  method: 'post',
  url: inchat.allChannels,
  data,
  headers: getHeaders(true)
})

/**
 * 
 * @param {string} conversationId
 * @param {Object} messageId 
 * @returns 
 */
const saveMessage = (data) => axios({
  method: 'post',
  url: inchat.saveMessage,
  data,
  headers: getHeaders(true)
})

const removeSaveMessage = (data) => axios({
  method: 'post',
  url: inchat.removeSaveMessage,
  data,
  headers: getHeaders(true)
})

const getOperatorById = (operatorId) => axios({
  method: 'get',
  url: inchat.getOperator.replace(':userId', operatorId),
  headers: getHeaders(true)
})

/**
 *
 * @param {Object} data
 * @param {String} data.conversationId
 * @param {String} [data.orderFilter]
 * @param {String} [data.typeFilter]
 * @param {String} [data.name]
 * @returns
 */
const getFilesConversation = (data) => axios({
  method: 'post',
  url: inchat.filesConversation,
  data,
  headers: getHeaders(true)
})

/**
 * 
 * @param {string} data.conversationId
 * @param {string} data.messageId
 * @param {number} data.from
 * @param {number} data.size
 * @returns 
 */
const getThreadsByMessage = (data) => axios({
  method: 'post',
  url: inchat.getThreadsByMessage,
  data,
  headers: getHeaders(true)
})

/**
 *
 * @param {Object} data
 * @param {String} data.name
 * @returns
 */
const createSection = (data) => axios({
  method: 'post',
  url: inchat.createSection,
  data,
  headers: getHeaders(true)
})

const getScheduledMessages = data => axios({
  method: 'POST',
  url: inchat.allScheduledMessages,
  data,
  headers: getHeaders(true)
})

const scheduleMessage = data => axios({
  method: 'POST',
  url: inchat.scheduleMessage,
  data,
  headers: getHeaders(true)
})

const updateScheduledMessage = ({ id, data }) => axios({
  method: 'PUT',
  url: inchat.scheduleMessageById.replace(':messageId', id),
  data,
  headers: getHeaders(true)
})

const deleteScheduledMessage = ({ id, conversationId }) => axios({
  method: 'DELETE',
  url: inchat.scheduleMessageById.replace(':messageId', id),
  data: { conversationId },
  headers: getHeaders(true)
})

const addMessageReaction = data => axios({
  method: 'POST',
  url: inchat.addReaction,
  data,
  headers: getHeaders(true)
})

const removeMessageReaction = data => axios({
  method: 'POST',
  url: inchat.removeReaction,
  data,
  headers: getHeaders(true)
})

const showTotalReactions = (idOperator) => axios({
  method: 'GET',
  url: inchat.showTotalReactions,
  headers: getHeaders(true),
  params: {
    userId: idOperator
  }
})

const showReactionsDetails = (idOperator) => axios({
  method: 'GET',
  url: inchat.showDetailsReactions,
  headers: getHeaders(true),
  params: {
    userId: idOperator
  }
})

/**
 *
 * @param {String} messageId
 * @param {Object} data
 * @param {String} data.conversationId
 * @returns
 */
const deleteMessage = (messageId, data) => axios({
  method: 'delete',
  url: inchat.actionMessage.replace(':messageId', messageId),
  data,
  headers: getHeaders(true)
})

const pinAdd = data => axios({
  method: 'POST',
  url: inchat.pinAdd,
  data,
  headers: getHeaders(true)
})

const pinList = data => axios({
  method: 'POST',
  url: inchat.pinList,
  data,
  headers: getHeaders(true)
})

const pinRemove = data => axios({
  method: 'POST',
  url: inchat.pinRemove,
  data,
  headers: getHeaders(true)
})

const draftAdd = data => axios({
  method: 'POST',
  url: inchat.draftAdd,
  data,
  headers: getHeaders(true)
})

const draftList = () => axios({
  method: 'GET',
  url: inchat.draftList,
  headers: getHeaders(true)
})

const draftUpdate = data => axios({
  method: 'POST',
  url: inchat.draftUpdate,
  data,
  headers: getHeaders(true)
})

const draftRemove = data => axios({
  method: 'POST',
  url: inchat.draftRemove,
  data,
  headers: getHeaders(true)
})

const draftConversation = data => axios({
  method: 'POST',
  url: inchat.draftConversation,
  data,
  headers: getHeaders(true)
})

const updateMessage = (messageId, data) => axios({
  method: 'put',
  url: inchat.actionMessage.replace(':messageId', messageId),
  data,
  headers: getHeaders(true)
})

const savedList = () => axios({
  method: 'GET',
  url: inchat.savedList,
  headers: getHeaders(true)
})

const createJoinLink = data => axios({
  method: 'POST',
  url: inchat.joinLink,
  data,
  headers: getHeaders(true)
})

const getMembersConversation = (data) => axios({
  method: 'post',
  url: inchat.members,
  data,
  headers: getHeaders(true)
})

/**
 *
 * @param {Object} data
 * @param {String} data.conversationId
 * @returns
 */
const seenMessages = (data) => axios({
  method: 'post',
  url: inchat.seenMessages,
  data,
  headers: getHeaders(true)
})

export default {
  updateConversation,
  getConversationList,
  getMainMenuInchat,
  getSectionInfo,
  updateSectionInfo,
  deleteSection,
  orderSections,
  searchUsers,
  createConversation,
  getConversationInfo,
  sendMessage,
  removeSaveMessage,
  getConversationMessages,
  uploadFiles,
  actionConversation,
  getAllChannels,
  saveMessage,
  getThreadsByMessage,
  getOperatorById,
  getFilesConversation,
  createSection,
  getScheduledMessages,
  scheduleMessage,
  updateScheduledMessage,
  deleteScheduledMessage,
  addMessageReaction,
  removeMessageReaction,
  showTotalReactions,
  showReactionsDetails,
  deleteMessage,
  pinAdd,
  pinRemove,
  pinList,
  draftAdd,
  draftList,
  draftUpdate,
  draftRemove,
  draftConversation,
  updateMessage,
  savedList,
  createJoinLink,
  getMembersConversation,
  seenMessages
}
